<template>
  <card-item
    card="item_partner"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['partners'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
        {
          title: "Магазины (доступы)",
          key: "shops",
          component: () => import("./Shops"),
        },
        {
          title: "Условия партнера",
          key: "fields",
          component: () => import("./Conditionals"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>